import axios, { CreateAxiosDefaults } from "axios";

export function axiosInstanceCreate(
  baseURL: string,
  options?: CreateAxiosDefaults<any>
) {
  const axiosInstance = axios.create({ baseURL, ...options });
  return axiosInstance;
}
